import React, { useEffect, useRef } from 'react'
import "../css/HomePageReference.css"

import * as imagesdata from '../imagesdata'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Reference = () => {
    const carouselRef = useRef(null);

    useEffect(() => {
        const element = carouselRef.current;
        const logos = element.querySelectorAll('.reference-logo');
        const numClones = 15; // Klon sayısını ayarlayabilirsiniz

        // Logoları klonla
        for (let i = 0; i < numClones; i++) {
            logos.forEach((logo) => {
                const clone = logo.cloneNode(true);
                element.appendChild(clone);
            });
        }
       

        // ScrollTrigger kullanarak sayfa kaydırma hareketini logoların yatay kaymasıyla senkronize et
        gsap.to(element, {
            x: () => (element.scrollWidth - window.innerWidth), // Element genişliği kadar yatayda kaydır
            ease: "none",
            scrollTrigger: {
                trigger: document.body, // Sayfanın tamamı
                start: "top top",
                end: "bottom bottom",
                scrub: true, // Kaydırma ile tamamen senkronize hareket eder
                onUpdate: (self) => {
                    const progress = self.progress; // Sayfanın kaydırma ilerlemesi (0 ile 1 arasında değer)
                    const direction = self.direction; // Aşağı (1) veya yukarı (-1) kaydırma yönü
                    const scrollAmount = (progress * (element.scrollWidth - window.innerWidth));

                    // Yön aşağıya doğruysa sağa, yukarıya doğruysa sola kaydır
                    gsap.set(element, { x: -scrollAmount });
                }
            }
        });
    }, []);

    return (
        <div className="reference-carousel-container">
            <div className="reference-carousel" ref={carouselRef}>
                <img src={imagesdata.AtlasLogo} alt="Marka 1" className="reference-logo" />
                <img src={imagesdata.TersLogo} alt="Marka 2" className="reference-logo" />
            </div>
        </div>
    )
}

export default Reference